import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import Login from './pages/Login';
import AcceptInvite from './pages/AcceptInvite';
import AdminUsers from './pages/AdminUsers';
import AdminRoute from './components/AdminRoute';
import Dashboard from './pages/Dashboard';
import Documents from './pages/Documents';
import DocumentEditor from './pages/DocumentEditor';
import Envelopes from './pages/Envelopes';
import EnvelopeCreate from './pages/EnvelopeCreate';
import EnvelopeDetail from './pages/EnvelopeDetail';
import SignDocument from './pages/SignDocument';
import Templates from './pages/Templates';
import TemplateEditor from './pages/TemplateEditor';
import UseTemplate from './pages/UseTemplate';
import AuditLog from './pages/AuditLog';
import OrgSettings from './pages/OrgSettings';
import EmailTemplates from './pages/EmailTemplates';
import Integrations from './pages/Integrations';
import Verify from './pages/Verify';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public */}
          <Route path="/login" element={<Login />} />
          <Route path="/invite/:token" element={<AcceptInvite />} />
          <Route path="/sign/:token" element={<SignDocument />} />
          <Route path="/verify/:certificateId" element={<Verify />} />

          {/* Protected */}
          <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="documents" element={<Documents />} />
            <Route path="documents/:docId/edit" element={<DocumentEditor />} />
            <Route path="envelopes" element={<Envelopes />} />
            <Route path="envelopes/create" element={<EnvelopeCreate />} />
            <Route path="envelopes/:envelopeId" element={<EnvelopeDetail />} />
            <Route path="templates" element={<Templates />} />
            <Route path="templates/:templateId/use" element={<UseTemplate />} />
            <Route path="templates/:templateId" element={<TemplateEditor />} />
            <Route path="audit-log" element={<AuditLog />} />
            <Route path="email-templates" element={<EmailTemplates />} />
            <Route path="integrations" element={<Integrations />} />
            <Route path="settings" element={<OrgSettings />} />
            <Route
              path="admin/users"
              element={(
                <AdminRoute>
                  <AdminUsers />
                </AdminRoute>
              )}
            />
          </Route>

          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
